import { useEffect, useState, useCallback } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import parentApi from "@/lib/parentApi";
import { ParentFormFill, ParentFormRows } from "@/components/parent/ParentFormFill";

export function StudentForms({ studentId }) {
  const [sends, setSends] = useState(null);
  const [open, setOpen] = useState(null);

  const load = useCallback(async () => {
    try { const { data } = await parentApi.get("/parent/forms"); setSends(data.filter((s) => s.student_id === studentId)); }
    catch { toast.error("Could not load forms"); }
  }, [studentId]);
  useEffect(() => { setSends(null); setOpen(null); load(); }, [load]);

  if (sends === null) return <div className="rounded-2xl bg-white p-10 text-center shadow-sm"><Loader2 className="h-6 w-6 animate-spin mx-auto text-slate-400" /></div>;
  if (open) return <ParentFormFill send={open} onClose={() => setOpen(null)} onDone={() => { setOpen(null); load(); }} />;

  return (
    <div className="space-y-2" data-testid="parent-student-forms">
      {sends.length === 0 && <div className="rounded-2xl bg-white p-8 text-center shadow-sm text-sm text-slate-500" data-testid="parent-forms-empty">No forms for this child yet.</div>}
      <ParentFormRows sends={sends} onOpen={setOpen} />
    </div>
  );
}
